// extracted by mini-css-extract-plugin
export default {"GuideContentBG":"GuideContent_GuideContentBG__j1g8d","GuideContent":"GuideContent_GuideContent__8+b0P"};